<template>
  <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group" transform="translate(14.293939, 14.829473) rotate(45.000000) translate(-14.293939, -14.829473) translate(-4.206061, -3.670527)" :fill="fill">
            <rect id="Rectangle" x="0" y="16" width="36.3636364" height="4.54545455" rx="2.27272727"></rect>
            <rect id="Rectangle-Copy" transform="translate(18.181818, 18.272727) rotate(90.000000) translate(-18.181818, -18.272727) " x="0" y="16" width="36.3636364" height="4.54545455" rx="2.27272727"></rect>
        </g>
    </g>
</svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#FFFFFF'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icons/CloseIcon.vue